export default __webpack_public_path__ + "static/media/bioluminescence.8775fc2c.jpg";